export const downloadFile = async (name: string, url: string): Promise<void> => {
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  a.remove();
};
